import { YhBox } from "@/erp_subpackage/components/YhBox";
import { importPropsConfig } from "@/erp_subpackage/utils/importFile";
import { Button, Input, message, Space, Switch, Table, Tooltip, Upload } from "antd";
import React from "react";
import { useTranslation } from 'react-i18next';
import { useWarehouseModel } from "../../warehouseModel";

//货位
export const ShelfTable = () => {
    const { t } = useTranslation();
    const {
        shelfPgCfg, shelfDataSource, setSelectedShelfRows, shopId,
        selectedShelfRows, shelfLoadData, setIShelfDrawer,
        shelfSearch, setShelfSearch, downloadTplShelf, onDisabled
    } = useWarehouseModel();


    const action = <div className="flex items-center">
        <Tooltip placement="topLeft" title= {t(`base.detail.ShelfTable.回车进行检索`)}>
            <Input
                allowClear
                datatype="round"
                placeholder= {t(`base.detail.ShelfTable.货位编码`)}
                className="mr-10"
                value={shelfSearch?.["code"]}
                onChange={(e) => setShelfSearch({ ...shelfSearch, "code": e.target.value })}
                onPressEnter={shelfLoadData}
            />
        </Tooltip>
        <Button
            className="btn-item"
            shape="round"
            onClick={() => setIShelfDrawer("add")}
        > {t(`base.detail.ShelfTable.新增`)}</Button>
        <Button
            className="btn-item"
            shape="round"
            onClick={() => {
                if (selectedShelfRows.length !== 1) {
                    message.warning(t(`base.detail.ShelfTable.请选择单条数据进行编辑`));
                    return;
                }
                setIShelfDrawer("edit");
            }}
        > {t(`base.detail.ShelfTable.编辑`)}</Button>
        <Upload showUploadList={false}  {...importPropsConfig(`/ci-storage/base/warehouse/shelf/import/${shopId}`, shelfLoadData, { shopId })}>
            <Button className="btn-item" shape="round"> {t(`base.detail.ShelfTable.导入`)}</Button>
        </Upload>
        <Button
            className="btn-item"
            shape="round"
            onClick={() => downloadTplShelf()}
        > {t(`base.detail.ShelfTable.下载模板`)}</Button>
    </div>


    const columns = [
        {
            title: t(`base.detail.ShelfTable.序号`),
            align: "center",
            render: (t, r, i) => <>{i + 1}</>
        },
        {
            title: t(`base.detail.ShelfTable.货位编号`),
            dataIndex: 'code',
        },
        {
            title: t(`base.detail.ShelfTable.所属仓库`),
            dataIndex: 'warehouseName',
        },
        {
            title: t(`base.detail.ShelfTable.创建人`),
            align: "center",
            dataIndex: 'createUser',
        },
        {
            title: t(`base.detail.ShelfTable.创建时间`),
            align: "center",
            dataIndex: 'createTime',
        },
        {
            title: t(`base.detail.ShelfTable.备注信息`),
            align: "center",
            dataIndex: 'note',
        }, {
            title: t(`base.detail.ShelfTable.操作`),
            align: "center",
            dataIndex: 'status',
            render: (text, record) => (
                <Space size="middle">
                    <Switch checked={text === 1} onChange={(checked) => {
                        onDisabled(record, checked);
                    }} />
                </Space>
            ),
        },
    ];

    const onRow = (record) => {
        let findArr = selectedShelfRows.find(item => item.id === record.id);
        if (findArr) {
            let filterArr = selectedShelfRows.filter(item => item.id !== record.id);
            setSelectedShelfRows(filterArr);
        } else {
            setSelectedShelfRows(origin => [...origin, record]);
        }
    };

    return (
        <YhBox title={<span style={{ paddingLeft: "20px" }}> {t(`base.detail.ShelfTable.货位信息`)}</span>} rightChildren={action} style={{ padding: "0", marginBottom: "10px" }}>
            <Table
                rowKey={record => record.id}
                rowSelection={{
                    selectedRowKeys: selectedShelfRows.map(item => item.id), //记录选中
                    onChange: (selectedRowKeys, selectedRows) => {
                        setSelectedShelfRows(selectedRows);
                    }
                }}
                columns={columns}
                dataSource={shelfDataSource}
                pagination={{
                    ...shelfPgCfg,
                    position: ["bottomCenter"],
                    showTotal: () => `${t(`base.detail.ShelfTable.共`)}${shelfPgCfg.total}${t(`base.detail.ShelfTable.条`)}`,
                    onChange: (pageNum, pageSize) => {
                        shelfLoadData({ pageNum, pageSize })
                    }
                }}
                onRow={record => ({
                    onClick: () => onRow(record)
                })}
                scroll={{ x: 'max-content' }}
            />
        </YhBox>
    )
}

